/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum MissingInvoiceComparisonDay {
  Pickup = "Pickup",
  Delivery = "Delivery",
}

export function instanceOfMissingInvoiceComparisonDay(value: any): boolean {
  for (const key in MissingInvoiceComparisonDay) {
    if (
      Object.prototype.hasOwnProperty.call(MissingInvoiceComparisonDay, key)
    ) {
      if (
        MissingInvoiceComparisonDay[
          key as keyof typeof MissingInvoiceComparisonDay
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function MissingInvoiceComparisonDayFromJSON(
  json: any,
): MissingInvoiceComparisonDay {
  return MissingInvoiceComparisonDayFromJSONTyped(json, false);
}

export function MissingInvoiceComparisonDayFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): MissingInvoiceComparisonDay {
  return json as MissingInvoiceComparisonDay;
}

export function MissingInvoiceComparisonDayToJSON(
  value?: MissingInvoiceComparisonDay | null,
): any {
  return value as any;
}

export function MissingInvoiceComparisonDayToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): MissingInvoiceComparisonDay {
  return value as MissingInvoiceComparisonDay;
}
